/** 開新分頁(此 Part 有為 Safari 做特殊處理) */
export const NEW_PAGE = 'new_page' as const;

/** 原頁取代 */
export const SAME_PAGE = 'same_page' as const;

export type HrefTargetType = typeof NEW_PAGE | typeof SAME_PAGE;

export const hrefTargetEnum: Record<string, HrefTargetType> = {
  [NEW_PAGE]: NEW_PAGE,
  [SAME_PAGE]: SAME_PAGE,
};

export default {
  NEW_PAGE,
  SAME_PAGE,
};
